import * as windowSize from "./window_size"

const ATTRIBUTES =
  {
    smallPalm: ["imgSmallPalm", "imgMobile", "imgHandheld", "imgPortable"],
    palm: ["imgPalm", "imgPalmAndUp", "imgMobile", "imgHandheld", "imgPortable"],
    tab: ["imgPalmAndUp", "imgTab", "imgTabAndUp", "imgHandheld", "imgPortable"],
    lap: ["imgPalmAndUp", "imgTabAndUp", "imgLap", "imgLapAndUp", "imgPortable"],
    desk: ["imgPalmAndUp", "imgTabAndUp", "imgLapAndUp"]
  }

const IMAGE_SELECTOR = '.js-img, [data-img]'
const FALLBACK_ATTR = 'img'

const getURL = (img: HTMLElement) : string | undefined => {
  let attributes : Array<string>
  if (windowSize.isSmallPalm()) {
    attributes = ATTRIBUTES.smallPalm
  } else if (windowSize.isPalm()) {
    attributes = ATTRIBUTES.palm
  } else if (windowSize.isTab()) {
    attributes = ATTRIBUTES.tab
  } else if (windowSize.isLap()) {
    attributes = ATTRIBUTES.lap
  } else {
    attributes = ATTRIBUTES.desk
  }

  for (const attr of attributes.reverse()) {
    const url = img.dataset[attr]
    if (url) {
      return url
    }
  }
  return img.dataset[FALLBACK_ATTR]
}

const processImages = (processor : () => void) : void => {
  processor()
  window.addEventListener('resize', processor)
  window.addEventListener('orientationchange', processor)
}

const setBackgroundImages = (images : NodeListOf<HTMLElement>) : void => {
  const onLoad = (img : HTMLElement, url : string) => () : void => {
    img.style.backgroundImage = `url(${url})`
  }

  images.forEach((img) => {
    const url = getURL(img)
    if (url) {
      const image = new Image()
      image.onload = onLoad(img, url)
      image.src = url
    }
  })
}

const defaultImages = () : NodeListOf<HTMLElement> =>
  document.querySelectorAll<HTMLElement>(IMAGE_SELECTOR)

const loadBackgroundImages = (images = defaultImages()) : void => {
  // In case images is null
  images = images || defaultImages()
  processImages(() => setBackgroundImages(images))
}

const appendImageTags = (images : NodeListOf<HTMLElement>) : void => {
  for (const node of Array.from(images)) {
    const img = node.querySelector("img")

    if (img?.src) continue // don't re-load if `img` already exists

    const url = getURL(node)

    if (url) {
      const image = new Image()
      image.src = url
      image.alt = ""
      node.innerHTML = ""
      node.appendChild(image)
    }
  }
}

const loadImageTags = (images = defaultImages()) : void => {
  if (images === null) {
    images = defaultImages()
  }
  processImages(()=> appendImageTags(images))
}

export {
  loadBackgroundImages,
  loadImageTags
}
